var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "alert", class: _vm.alertClass, attrs: { role: "alert" } },
    [
      _c("i", { class: _vm.icon }),
      _vm._v(" "),
      _vm.message ? _c("p", [_vm._v(_vm._s(_vm.message))]) : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }